import React from "react";
import GcStudentMasterLayout from "../../../layouts/gcstudent/GcStudentMasterLayout";
import AboutDigiLib from "../../../components/gcstudent/aboutsection/HeroSection";
import OurMission from "../../../subsreens/gcstudent/ourmission/OurMission";
import WhyChooseUs from "../../../subsreens/gcstudent/whychooseus/WhyChooseUs";
import OurTeam from "../../../subsreens/gcstudent/ourteem/OurTeam";

const GcAbout = () => {
    const aboutData = {title : 'About', highLight : 'GGCW Library', subTitle : 'Empowering students and educators through digital access to knowledge and resources.' };
    return <>
        <GcStudentMasterLayout>
            <AboutDigiLib heroData = {aboutData}/>
            <OurMission/>
            <WhyChooseUs/>
            <OurTeam/>
        </GcStudentMasterLayout>
    </>
}

export default GcAbout;

